<template>
    <div>
        <VSelect v-model="profissionais.responsavel"
                 label="Responsável" :items="profissionaisLista"
                 item-value="id" item-text="nomeFantasia"
                 return-object
                 @change="onSelectResponsavel($event)">
        </VSelect>
        <VSelect v-model="profissionais.auxiliares"
            label="Auxiliares"
            :items="removerResponsavelDaListaAuxiliares(profissionais.responsavel)"
            item-value="id" item-text="nomeFantasia"
            :disabled="isResponsavelNenhum"
                 multiple
            return-object>
            <template v-slot:selection="data">
                {{ data.item.nomeFantasia }}
            </template>
        </VSelect>
    </div>
</template>
<script>
    export default {
        mounted(){
            this.profissionais = this.value;
        },
        name: 'SelectProfissionais',
        props: {
            value: Object,
            profissionaisLista: Array
        },
        data() {
            return {
                profissionais: {
                    auxiliares: [],
                    responsavel: {
                        id: null,
                        nomeFantasia: null,
                        preferencial: false
                    }
                }
            }
        },
        computed: {
            isResponsavelNenhum(){
             if(this.profissionais.responsavel === null || this.profissionais.responsavel.id === null ){
                 this.limparListaDeAuxiliares()
                 return true
             } else {
                 return false
             }
            }
        },
        watch: {
            value: {
                handler(profissionais) {
                    this.profissionais = profissionais;
                },
                deep: true
            },
            profissionais: {
                handler(profissionais){
                    if (profissionais !== this.value) {
                        this.$emit('input', profissionais)
                    }
                },
                deep: true
            }
        },
        methods: {
            limparListaDeAuxiliares(){
                this.profissionais.auxiliares = []
            },
            removerResponsavelDaListaAuxiliares(profissionalResponsavel) {
                if (profissionalResponsavel !== null){
                    return this.profissionaisLista.filter(pro => pro.id !== profissionalResponsavel.id && pro.id !== null && pro.assistente == 1)
                }
            },
            onSelectResponsavel(profissionalResponsavel) {
                this.profissionais.auxiliares = this.profissionais.auxiliares.filter(auxiliar => auxiliar.id !== profissionalResponsavel.id)
            }
        }
    }
</script>
